import { loaderAction, usersListAction, filterWindowAction, paginationAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";

export const getUsersThunk = (args) => async (dispatch, getState) => {
    const { user, filterWindow } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('page', args.page);
        formData.append('without_subscriptions', args.without_subscriptions || '');
        formData.append('expire_to', args.expire_to || '');
        formData.append('workouts_less_than', args.workouts_less_than || '');
        formData.append('registration_not_later', args.registration_not_later || '');
        formData.append('not_been_x_months', args.not_been_x_months || '');
        formData.append('last_workout_from', args.last_workout_from || '');
        formData.append('last_workout_to', args.last_workout_to || '');
        formData.append('birthday_from', args.birthday_from || '');
        formData.append('birthday_to', args.birthday_to || '');
        formData.append('admin', args.admin || '');
        formData.append('coach', args.coach || '');
        formData.append('workouts_count', args.workouts_count || '');
        formData.append('debt', args.debt || '');
        formData.append('without_workouts', args.without_workouts || '');

        const response = await api({ data: formData, link: 'get_users' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Если список пользователей пуст, показываем уведомление
            if (!response.users.length) {
                growl({ type: 'warning', message: 'Список посетителей пуст' });
            }

            // Если открыты фильтры, закрываем их
            if (filterWindow) {
                dispatch(filterWindowAction(false));
            }

            // Сохраняем список пользователей, только если пришли данные
            if (response.users.length) {
                dispatch(usersListAction(response.users));
            }
            dispatch(paginationAction(response.pagination));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }
};